/* eslint no-param-reassign: ['error', {
    props: true,
    ignorePropertyModificationsFor: ['conditions', 'reduced']
  }]
*/

import { identifier, IDENTIFIERS, FAILED } from '@sdk/views/Simulations/Read/status';

export const SUGGESTED = 'suggested';
export const MINIMUM = 'minimum';
export const ORIGINAL = 'original';
export const EMPTY = ['original_condition', '', null, undefined];

const DESC = 'desc';
const ASC = 'asc';

const WEIGHTS = [{
  prop: 'installments',
  sort: DESC,
}, {
  prop: 'first_installment_value',
  sort: ASC,
}, {
  prop: 'down_payment',
  sort: ASC,
}];

export function weight(a, b, property = 0) {
  const current = WEIGHTS[property];

  if (current) {
    const x = a[current.prop];
    const y = b[current.prop];

    if (x === y) {
      return weight(a, b, property + 1);
    }

    return (current.sort === DESC ? x < y : x > y) ? 1 : -1;
  }

  return 0;
}

function available(a, b) {
  if (a.available === b.available) {
    return 0;
  }

  return a.available ? -1 : 1;
}

function sort(conditions) {
  return conditions
    .sort(weight)
    .sort(available);
}

function subgroup(condition) {
  switch (condition.suggestion_reason) {
    case 'bank_suggested_down_payment':
      return SUGGESTED;
    case 'bank_minimum_down_payment':
      return MINIMUM;
    default:
      return ORIGINAL;
  }
}

export function processing(condition) {
  return !condition.process_task || !condition.process_task.ended_at;
}

export function statusFallback(condition) {
  let status = identifier(condition.pre_approval_status);

  if (status !== IDENTIFIERS.DENIED && !condition.available && condition.reason) {
    status = IDENTIFIERS[FAILED];
  }

  return status;
}

function statify(conditions, condition) {
  const status = statusFallback(condition);

  if (!conditions[status]) {
    conditions[status] = {
      [ORIGINAL]: [],
      [SUGGESTED]: [],
      [MINIMUM]: [],
    };
  }

  conditions[status][subgroup(condition)].push(condition);

  return conditions;
}

function group(conditions) {
  const grouped = conditions.reduce(statify, {});

  return Object.keys(grouped)
    .sort((a, b) => b - a)
    .map(key => ({
      key,
      conditions: Object.keys(grouped[key]).reduce((reduced, sub) => {
        reduced[sub] = sort(grouped[key][sub]);

        return reduced;
      }, {}),
    }))
    .filter(g => Object.values(g.conditions).some(sub => sub.length));
}

export function variable(condition) {
  const flow = Object.values(condition.payment_flow || {});

  if (flow.length) {
    return flow.some(value => value !== flow[0]);
  }

  return !condition.fixed_installments;
}

export function fixed(condition) {
  return !variable(condition);
}

export default function normalizer(conditions) {
  return {
    fixed: group(conditions.filter(fixed)),
    variable: group(conditions.filter(variable)),
  };
}
